import React, { useRef, useState } from 'react';
import Accordion from '../../atoms/Accordion';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosPerguntas.css';

const faqs = [
  {
    pergunta: 'Quanto custa um carro elétrico?',
    resposta:
      'O preço de um carro elétrico pode variar conforme algumas variáveis, como categoria, marca ou potência do veículo. Apesar disso, é sempre importante ficar atento às funcionalidade e todas as características que podem interferir no veículo. No Santander, você também conta com taxas reduzidas no financiamento de veículos elétricos.',
  },
  {
    pergunta: 'Vale a pena comprar um veículo elétrico no Brasil?',
    resposta:
      'A compra de veículos elétricos é uma ótima opção a médio/longo prazo. Isso porque, além da economia com combustível, existe também reduções no custo de manutenção e até mesmo de tributos.',
  },
  {
    pergunta: 'Quanto tempo dura a bateria de um carro elétrico?',
    resposta:
      'A autonomia de um veículo elétrico pode variar conforme sua potência. Em média, um carro elétrico possui uma autonomia de 300 a 400 quilômetros.',
  },
  {
    pergunta: 'Como carregar um carro ou moto elétrica?',
    resposta: `No caso dos carros elétricos, existem pontos de recarga públicos e particulares, que
      fornecem energia para carregar o carro de forma rápida. Além disso, os carros também
      podem ser carregados, em caso de emergência, em tomadas tradicionais, mas é
      importante enfatizar que dessa forma o tempo de recarga é relativamente elevado.
      <br />
      Já no caso das motos elétricas, elas são carregadas em tomadas tradicionais. Vale
      lembrar também que algumas motos possuem a bateria removível, o que torna o processo
      de carregamento ainda mais fácil.`,
  },
  {
    pergunta: 'Como funciona um carro elétrico?',
    resposta:
      'Os veículos elétricos funcionam a partir de um motor que é alimentado por uma bateria recarregável. Essa bateria fornece energia para o motor, que aciona as rodas do veículo. Assim, os elétricos não emitem CO2 durante a sua condução e são mais sustentáveis.',
  },
  {
    pergunta: 'Por que os carros elétricos são mais silenciosos?',
    resposta:
      'Em resumo, os carros elétricos são mais silenciosos porque não geram ruídos com o escapamento e possuem menos equipamentos em sua parte mecânica.',
  },
  {
    pergunta: 'Posso financiar uma moto ou carro elétrico?',
    resposta:
      'Com a Santander Financiamentos, você pode financiar veículos elétricos de forma fácil e com taxa reduzida em relação aos veículos a combustão. Conte com a gente para realizar seu sonho de ter um carro sustentável!',
  },
];

const faqs2 = [
  {
    pergunta: 'Como funciona o Move Brasil para carros elétricos?',
    resposta:
      'O Move Brasil é um programa do Governo Federal para facilitar o financiamento de veículos 0km para motoristas de aplicativo e taxistas. Entre os modelos elegíveis estão carros elétricos que atendem aos critérios definidos pelo programa, oferecendo condições mais acessíveis para a renovação da frota.',
  },
  {
    pergunta: 'Quais carros elétricos participam do Move Brasil?',
    resposta:
      'Entre os modelos elétricos divulgados como elegíveis para o Programa Move Brasil estão o BYD Dolphin Mini e o BYD Dolphin, que se enquadram no limite de valor de até R$ 150 mil previsto pelo programa.',
  },
  {
    pergunta: 'Como financiar um BYD pelo Move Brasil?',
    resposta:
      'Para financiar um veículo da BYD pelo Move Brasil, basta verificar se o modelo desejado está entre os elegíveis, realizar uma simulação de financiamento e seguir o processo de contratação junto a Santander Financiamentos.',
  },
  {
    pergunta: 'Quem pode participar do Programa Move Brasil?',
    resposta:
      'Podem participar motoristas de aplicativo com cadastro ativo há pelo menos 12 meses na mesma plataforma e que tenham realizado no mínimo 100 corridas nesse período. Taxistas com licenças e registros ativos também são elegíveis.',
  },
  {
    pergunta: 'É possível financiar um carro elétrico pelo Move Brasil?',
    resposta:
      'Sim. O programa contempla veículos novos que atendam aos critérios de sustentabilidade definidos pelo governo, incluindo modelos elétricos, híbridos e flex de montadoras habilitadas.',
  },
  {
    pergunta: 'Qual o valor máximo do veículo elétrico financiado pelo programa?',
    resposta:
      'O Move Brasil permite o financiamento de veículos elétricos 0km com valor de até R$ 150 mil, desde que estejam dentro das regras e da lista de modelos elegíveis do programa.',
  },
  {
    pergunta: 'Quais são as vantagens de financiar um carro elétrico pelo Move Brasil?',
    resposta:
      'Além das condições especiais de crédito, o motorista pode reduzir gastos com abastecimento e manutenção, já que os veículos elétricos costumam apresentar menor custo operacional quando comparados aos modelos convencionais.',
  },
  {
    pergunta: 'O financiamento do Move Brasil exige entrada?',
    resposta:
      'O programa prevê modalidades com condições facilitadas, incluindo possibilidade de entrada reduzida ou até mesmo entrada zero, dependendo da instituição financeira e da análise de crédito.',
  },
  {
    pergunta: 'Como saber se um veículo elétrico participa do Move Brasil?',
    resposta:
      'A elegibilidade depende das regras do programa e da lista de veículos aprovados pelas montadoras participantes. Antes de contratar o financiamento, consulte as opções disponíveis e confirme se o modelo desejado está habilitado.',
  },
  {
    pergunta: 'Como solicitar o financiamento pelo Move Brasil?',
    resposta:
      'O primeiro passo é realizar o cadastro na plataforma oficial do programa: gov.br/movebrasil e autorizar a análise de elegibilidade. Após a aprovação, o motorista poderá procurar uma instituição financeira participante para concluir a contratação.',
  },
  {
    pergunta:
      'Vale a pena trocar um carro a combustão por um elétrico para trabalhar com aplicativos?',
    resposta:
      'Para muitos motoristas, sim. Além da economia com combustível, os veículos elétricos oferecem condução silenciosa, menor necessidade de manutenção e podem gerar redução dos custos operacionais ao longo do tempo, especialmente para quem roda muitos quilômetros por mês.',
  },
];

function CarrosEletricosPerguntas() {
  const accRefs = useRef(faqs.map(() => React.createRef()));
  const accRefs2 = useRef(faqs2.map(() => React.createRef()));

  const handleAccChange = (index, open) => {
    if (!open) return;
    accRefs.current.forEach((ref, i) => {
      if (i !== index && ref.current) {
        ref.current.close();
      }
    });
  };

  const handleAccChange2 = (index, open) => {
    if (!open) return;
    accRefs2.current.forEach((ref, i) => {
      if (i !== index && ref.current) {
        ref.current.close();
      }
    });
  };

  const [verMais, setVerMais] = useState(false);
  const QTD_VISIVEL = 2;

  return (
    <>
      <section id="perguntas">
        <Container>
          <h2 className="title-perguntas">
            Saiba mais sobre o financiamento de veículos elétricos e tire suas dúvidas
          </h2>

          <div className="group-perguntas">
            {faqs.map((faq, index) => (
              <Accordion
                key={index}
                title={faq.pergunta}
                startOpen={index === 0}
                accordionRef={accRefs.current[index]}
                onChange={(open) => handleAccChange(index, open)}
              >
                <p dangerouslySetInnerHTML={{ __html: faq.resposta }} />
              </Accordion>
            ))}
          </div>

          <h2 className="title-perguntas">Programa Move Brasil para Veículos Elétricos</h2>

          <div className="group-perguntas">
            {faqs2.map((faq, index) => {
              const oculto = index >= QTD_VISIVEL && !verMais;
              return (
                <div key={index} style={oculto ? { display: 'none' } : undefined}>
                  <Accordion
                    title={faq.pergunta}
                    accordionRef={accRefs2.current[index]}
                    onChange={(open) => handleAccChange2(index, open)}
                  >
                    <p dangerouslySetInnerHTML={{ __html: faq.resposta }} />
                  </Accordion>
                </div>
              );
            })}

            {faqs2.length > QTD_VISIVEL && !verMais && (
              <button className="link-faq" type="button" onClick={() => setVerMais(true)}>
                Ver mais
              </button>
            )}
            {verMais && (
              <>
                <br />
                <a href="duvidas-frequentes.html" className="link-faq">
                  Mostrar todas as perguntas
                </a>
              </>
            )}
          </div>
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosPerguntas;
